
import { Options, Vue } from "vue-class-component";
import * as echarts from 'echarts';
import { getReportInfo, getWxConfig } from "@/api/index";
import moment from 'moment';
import { Dialog } from "vant";
import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'
import wx from 'weixin-js-sdk'
import { isNewBridgeView } from '@/assets/js/utils.js'
import { wxShare } from '@/utils/nativeFn'

@Options({
  components: {},
})
export default class Report extends Vue {
  reportInfo: any = null
  startDate: string = ''
  endDate: string = ''
  isLoading: boolean = false
  isIbookApp: boolean = navigator.userAgent.indexOf('ibook') > -1
  weekStudyVideo: number = 0
  allStudyVideo: number = 0
  encouragements = {
    1: '还不错哈，但还要更加努力哦！( ´▽｀)',
    2: '很优秀，再努力一点就更棒了！d(^_^o)',
    3: '太厉害了，要继续保持哦！o(^▽^)o'
  }
  async mounted() {
    await this.getWxConfig();
    this.getReportInfo();
  }
  getWxConfig() {
    return new Promise((resolve, reject) => {
      let data = {
        url: location.href
      }
      getWxConfig(data).then((res) => {
        resolve('获取微信配置成功')
        if (res.data.code !== 0) {
          console.log('获取微信签名错误：', res.data.message)
          return
        }
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.data.signature,// 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
        })
      }).catch((err) => {
        reject(err)
        console.log('获取微信签名错误：', err)
      })
    })
  }
  // 获取报告详情
  getReportInfo() {
    // @ts-ignore
    const report_id = this.$route.query['report_id']
    if (!report_id) {
      Dialog.alert({
        message: '没有报告id'
      })
      return
    }
    this.isLoading = true
    getReportInfo({report_id}).then((res) => {
      this.isLoading = false
      if (res.data.code !== 0 || (res.data.data && JSON.stringify(res.data.data) === '{}')) {
        Dialog.alert({
          message: '暂无报告数据，请联系客服老师'
        })
        return
      }
      this.reportInfo = res.data.data
      this.startDate = moment.unix(this.reportInfo.basic_info.start_time).format('YYYY.MM.DD')
      this.endDate = moment.unix(this.reportInfo.basic_info.end_time).format('YYYY.MM.DD')
      this.weekStudyVideo = this.secondToMinute(this.reportInfo.data.week_videos)
      this.allStudyVideo = this.secondToMinute(this.reportInfo.data.total_videos)
      this.setWxShare() //设置微信分享标题，文字，图片
      this.$nextTick(() => {
        this.initHistogram()
        // this.initPieChart()
      })
      if (this.isIbookApp) {
        let wxData = {
          webpageUrl: location.href,
          title: this.reportInfo.wechat.title,
          description: this.reportInfo.wechat.describe,
          thumbData: ''
        }
        if (isNewBridgeView()) {
          wxShare(wxData, (res) => {
            console.log('微信分享', res)
          })
          return
        }
        mobileNativeSDK.wxShare(wxData);
      }
    }).catch((err) => {
      this.isLoading = false
      console.log(err, '获取报告失败')
      Dialog.alert({
        message: '服务器错误，请稍后再试'
      })
    })
  }
  secondToMinute(secondTime: number) {
    if (!secondTime) {
      return 0
    }
    const min = Math.round(secondTime / 60)
    return min
  }
  // 设置微信分享的标题，文字和图片
  setWxShare() {
    let wechatData = this.reportInfo.wechat
    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
      wx.updateAppMessageShareData({ 
        title: wechatData.title, // 分享标题
        desc: wechatData.describe, // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://cdn.xueersibook.com/ibook/images/wx_share_logo.png', // 分享图标
        success: function () {
          // 设置成功
          console.log('设置分享给好友成功')
        }
      })
      wx.updateTimelineShareData({ 
        title: wechatData.title, // 分享标题
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://cdn.xueersibook.com/ibook/images/wx_share_logo.png', // 分享图标
        success: function () {
          // 设置成功
          console.log('设置分享到朋友圈成功')
        }
      })
    });
  }
  initHistogram() {
    // 基于准备好的dom，初始化echarts实例
    let videoData = []
    let correctData = []
    this.reportInfo.chart.forEach(item => {
      let video_num = this.secondToMinute(item.video_num)
      videoData.push(video_num)
      correctData.push(item.correct_ques_num)
    });
    const histogramMainDom: any = document.getElementById('histogramMain')
    var myChart = echarts.init(histogramMainDom);
    const colors = ['#009DFF', '#FFAC09'];
    const histogramOption = {
      color: colors,
      tooltip: {
        show: false,
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      grid: {
        left: '10%',
        top: '14%',
        right: '8%',
        bottom: '12%'
      },
      legend: {
        selectedMode: false,
        data: ['视频时长', '拍批题数(大题)']
      },
      xAxis: [
        {
          type: 'category',
          axisTick: {
            alignWithLabel: true
          },
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '',
          position: 'right',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: colors[1]
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        },
        {
          type: 'value',
          name: '',
          position: 'left',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: colors[0]
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        }
      ],
      series: [
        {
          name: '视频时长',
          type: 'bar',
          yAxisIndex: 1,
          data: videoData
        },
        {
          name: '拍批题数(大题)',
          type: 'bar',
          data: correctData
        }
      ]
    };
    // 绘制图表
    myChart.setOption(histogramOption);
  }
  initPieChart() {
    const pieChartDom: any = document.getElementById('pieChart')
    var myChart = echarts.init(pieChartDom);
    const rightNum = this.reportInfo.data.right_num
    const wrongNum = this.reportInfo.data.correct_num - rightNum
    const pieOption = {
      series: [
        {
          type: 'pie',
          data: [
            {
              value: wrongNum,
              name: `答错${wrongNum}题`,
              itemStyle: {color: '#FFAC09'}
            },
            {
              value: rightNum,
              name: `答对${rightNum}题`,
              itemStyle: {color: '#009DFF'}
            }
          ]
        }
      ]
    };
    myChart.setOption(pieOption)
  }
  
}
